import { render, staticRenderFns } from "./modalAcceptMpr.vue?vue&type=template&id=299c356a&scoped=true"
import script from "./modalAcceptMpr.vue?vue&type=script&lang=js"
export * from "./modalAcceptMpr.vue?vue&type=script&lang=js"
import style0 from "./modalAcceptMpr.vue?vue&type=style&index=0&id=299c356a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299c356a",
  null
  
)

export default component.exports